import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useCartStore } from '../stores/useCartStore';
import { useCurrencySymbol } from '../lib/currency';

export function ConfirmationPage() {
  const { tableId } = useParams<{ tableId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const currencySymbol = useCurrencySymbol();

  const { orderId, total } = location.state || {};
  const { clearAll } = useCartStore();

  React.useEffect(() => {
    // El carrito se limpia definitivamente al llegar con éxito a la confirmación
    clearAll();
  }, []);

  const handleBackToHome = () => {
    navigate(`/dashboard/${tableId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-8 shadow-lg text-center max-w-md w-full">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-green-100 dark:bg-green-900/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-green-600 dark:text-green-400" />
        </div>

        {/* Success Message */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          ¡Pagaras en el local!
        </h1>

        <p className="text-gray-600 dark:text-gray-400 mb-6">
          El personal te avisará cuando tu pedido esté listo.
        </p>

        {/* Order Details */}



        {/* Action Button */}
        <button
          onClick={handleBackToHome}
          className="w-full bg-sky-500 hover:bg-sky-600 text-white py-3 rounded-lg font-medium transition-colors mb-4"
        >
          Volver al Inicio
        </button>

        {/* Theme Toggle */}

      </div>
    </div>
  );
}